export enum TICKET_ERROR {
  sendTicket = 'No ha sido posible enviar el ticket',
  getTicketData = 'Error getting tickets from indexed DB',
  insertTicketData = 'Error inserting tickets into indexed DB',
}
